module.exports = __webpack_public_path__ + "img/矩形 819@2x.02cea44d.png";